var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card center nubii-color",staticStyle:{"min-height":"70px"}},[_c('div',[_c('h1',[_vm._v(_vm._s(_vm.$i18n.t("admin.dashboard.welcome")))]),_c('p',[_vm._v(_vm._s(_vm.$i18n.t("admin.dashboard.welcomeDescription")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }